export default __webpack_public_path__ + "static/media/logoPadSales.abe5a3c6.svg";